<template>
    <header id="app-header">
        <h1>Dart-score.app</h1>
        <a href="https://paypal.me/sygnal14" >
            <font-awesome-icon style="color: white; margin: 35px 5px" :icon="['fab', 'paypal']"></font-awesome-icon>
        </a>
        <font-awesome-icon style="color: white; margin: 35px 5px" :icon="['fab', 'sass']"></font-awesome-icon>
        <font-awesome-icon style="color: white; margin: 35px 5px" :icon="['fab', 'vuejs']"></font-awesome-icon>
        <font-awesome-icon style="color: white; margin: 35px 5px" :icon="['fab', 'font-awesome']"></font-awesome-icon>
    </header>
</template>

<script>
    export default {
        name: "AppHeader"
    }
</script>

<style scoped lang="scss">

</style>